import { createApi } from "@/api/ApiFactory";
import { config } from "@/config/config";

const ExportApi = createApi(config.EXPORT_API_URL);

export default ExportApi;
